import { Link, useLocation } from "react-router-dom";
import { Phone, MapPin, Mail } from "lucide-react";
import { SITE, SERVICES } from "../data/site";

export const Footer = () => {
  const { pathname } = useLocation();
  const isCleanoutPage = pathname === "/estate-cleanouts";
  return (
    <footer className="bg-forest-deep text-ivory" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-5">
              <img src="/images/logo-white.png" alt="MacWay Estate Services" className="h-16 w-auto" />
            </div>
            <p className="text-ivory/70 text-sm leading-relaxed">
              Warm, practical help with estate sales, cleanouts, downsizing, and everything in between — handled
              carefully, from the first call to the final sweep.
            </p>
          </div>

          <div>
            <h4 className="font-sans text-sm font-bold uppercase tracking-[0.18em] text-brass mb-5">Services</h4>
            <ul className="space-y-2.5 text-sm text-ivory/75">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={s.link} className="hover:text-brass transition-colors">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-sm font-bold uppercase tracking-[0.18em] text-brass mb-5">Company</h4>
            <ul className="space-y-2.5 text-sm text-ivory/75">
              <li><Link to="/" className="hover:text-brass transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-brass transition-colors">Services</Link></li>
              <li><Link to="/services/estate-sales" className="hover:text-brass transition-colors">Estate Sales</Link></li>
              <li><Link to="/estate-cleanouts" className="hover:text-brass transition-colors">Estate Cleanouts</Link></li>
              <li><Link to="/services/cleanouts-downsizing" className="hover:text-brass transition-colors">Cleanouts & Downsizing</Link></li>
              <li><Link to="/upcoming-estate-sales" className="hover:text-brass transition-colors">Upcoming Estate Sales</Link></li>
              <li><Link to="/employment-opportunities" className="hover:text-brass transition-colors">Employment Opportunities</Link></li>
              <li><Link to="/about" className="hover:text-brass transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-brass transition-colors">Contact / Request a Quote</Link></li>
              <li><Link to="/privacy" className="hover:text-brass transition-colors">Privacy Policy</Link></li>
              <li className="pt-2 text-ivory/45 uppercase tracking-[0.18em] text-[0.65rem] font-bold">Service Areas</li>
              <li><Link to="/service-areas/maryland" className="hover:text-brass transition-colors">Maryland</Link></li>
              <li><Link to="/service-areas/northern-virginia" className="hover:text-brass transition-colors">Northern Virginia</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-sans text-sm font-bold uppercase tracking-[0.18em] text-brass mb-5">Talk to Us</h4>
            <a
              href={SITE.phoneHref}
              className="inline-flex items-center gap-2 text-lg font-semibold hover:text-brass transition-colors"
              data-testid="footer-phone-link"
            >
              <Phone className="w-5 h-5" />
              {SITE.phone}
            </a>
            <a
              href={SITE.emailHref}
              className="mt-3 inline-flex items-center gap-2 text-sm font-semibold hover:text-brass transition-colors break-all"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4 shrink-0" />
              {SITE.email}
            </a>
            <p className="mt-4 inline-flex items-start gap-2 text-sm text-ivory/70">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span data-testid="footer-service-area">
                {isCleanoutPage ? "Serving Maryland and Northern Virginia" : `Proudly serving ${SITE.serviceArea}`}
              </span>
            </p>
            <Link to="/contact" className="btn-brass mt-6 text-xs" data-testid="footer-quote-cta">
              Request a Quote
            </Link>
          </div>
        </div>

        <div className="border-t border-ivory/15 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-ivory/50">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <p>Estate sales · Cleanouts · Downsizing · Judgment-free help</p>
        </div>
      </div>
    </footer>
  );
};
